import React from 'react';
import index from '../traducciones/index';
import Footer from '../components/Footer';
import legal from '../traducciones/legal'
import ReactHtmlParser from 'react-html-parser';
import {Link, navigateTo} from "gatsby-link";

export default class Legal extends React.Component {
    state= {
        lang: this.props.location.state ? this.props.location.state.lang : 'es',
        traducciones: legal,
    };

    pickLang = (event) => {
        const lang = event.target.id

        switch (lang) {
            case 'ca':
                this.setState(()=>({ lang: 'ca'}));
                break;
            case 'es':
                this.setState(()=>({ lang: 'es'}));
                break;
            case 'en':
                this.setState(()=>({ lang: 'en'}));
                break;
            default:
                this.setState(()=>({ lang: 'en'}));
                break;
        }

    }

    render() {
        return (
            
            <div>
                <div className='infoPages'>
                    <h4 onClick={()=> 
                            navigateTo({
                                pathname: '/',
                                state: {
                                    lang: this.state.lang
                                },
                            })
                        } > {this.state.traducciones.volver[this.state.lang]}
                    </h4>
                    <h2>{this.state.traducciones.titulo[this.state.lang]}</h2>
                    <p>{ReactHtmlParser(this.state.traducciones.texto[this.state.lang])}</p>
                    
                    <h4 onClick={()=> 
                            navigateTo({
                                pathname: '/',
                                state: {
                                    lang: this.state.lang
                                },
                            })
                        } > {this.state.traducciones.volver[this.state.lang]}
                    </h4>
                </div>
                <div className='fill'></div>
                <Footer 
                            pickLang={this.pickLang} 
                            copyright={this.state.traducciones.copyright} 
                            lang={this.state.lang} 
                            scroll={this.scroll}
                            location = {this.props.history.location.pathname}
                            privacy = {index.privacy}
                            terminosShort = {index.terminosShort}
                            alternativeDisputeResolution = {index.alternativeDisputeResolution}                  
                />
            </div>
        )
    }   
};



// WEBPACK FOOTER //
// ./src/pages/privacy.js